import React from "react";

const avenewImg = ({
  wSize = "426",
  hSize = "208",
  bgColor = "#eeeeee",
  color = "#666666",
  ...props
}) => {
  return (
    <svg
      width="426"
      height="208"
      viewBox="0 0 426 208"
      {...props}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#cls-1)">
        <path
          className="cls-2"
          d="M142.86,91.81h-12v4.84l6,5.73,6-5.73Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M151.22,61.32a21.07,21.07,0,0,0-28.76,0,19,19,0,0,0-4.41,6.26,18.56,18.56,0,0,0,0,14.85,19,19,0,0,0,4.41,6.27l3.84,3.66V66.23a.64.64,0,0,1,0-.24.6.6,0,0,1,.14-.2.7.7,0,0,1,.21-.14.74.74,0,0,1,.25-.05h19.77a.66.66,0,0,1,.46.19.6.6,0,0,1,.19.44V92.37l3.84-3.67a19,19,0,0,0,4.41-6.26A18.51,18.51,0,0,0,157.18,75a18.71,18.71,0,0,0-1.55-7.43A19,19,0,0,0,151.22,61.32Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M137.89,76.78H135.6V79h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M132.41,83.7h-2.29v2.21h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M132.41,76.78h-2.29V79h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M132.41,69.87h-2.29v2.21h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M143.4,69.87h-2.29v2.21h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M143.4,83.7h-2.29v2.21h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M137.89,69.87H135.6v2.21h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M137.89,83.7H135.6v2.21h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M143.4,76.78h-2.29V79h2.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M183.09,85l-.41-2.15h-.15a8.11,8.11,0,0,1-6.36,2.63c-4.54,0-7.21-3.15-7.21-6.59,0-5.61,5.2-8.28,13.08-8.26v-.28c0-1.14-.64-2.78-4.07-2.78a13.11,13.11,0,0,0-6.14,1.62l-1.29-4.3A18.65,18.65,0,0,1,179.2,63c7.42,0,9.77,4.24,9.77,9.31v7.52a30.41,30.41,0,0,0,.35,5.22Zm-.84-10.19c-3.65,0-6.46.83-6.46,3.4a2.46,2.46,0,0,0,2.75,2.58,3.89,3.89,0,0,0,2.2-.68,3.71,3.71,0,0,0,1.38-1.8,4,4,0,0,0,.13-1.14Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M196.34,63.49l3,10c.54,1.82.92,3.52,1.27,5.25h.15c.34-1.78.72-3.39,1.23-5.25l2.86-10h7.29l-8.3,21.56h-6.91l-8.1-21.56Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M217.22,76.42c.21,2.78,3.05,4.11,6.28,4.11a19.05,19.05,0,0,0,6.14-.92l.92,4.54a22.2,22.2,0,0,1-8.07,1.36c-7.55,0-11.88-4.25-11.88-11,0-5.48,3.53-11.54,11.23-11.54,7.22,0,9.95,5.43,9.95,10.77a12.4,12.4,0,0,1-.25,2.65Zm8.14-4.59c0-1.61-.74-4.37-3.89-4.37-2.93,0-4.11,2.59-4.31,4.37Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M233.19,70.37c0-2.68-.09-5-.19-6.88h6l.33,3h.15A8.14,8.14,0,0,1,246.37,63c4.55,0,8,2.94,8,9.28V85.05H247.4v-12c0-2.77-1-4.67-3.51-4.67A3.73,3.73,0,0,0,240.37,71a4.65,4.65,0,0,0-.25,1.66V85.05h-6.93Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M262.47,76.42c.21,2.78,3,4.11,6.28,4.11a19,19,0,0,0,6.13-.92l.94,4.54a22.2,22.2,0,0,1-8.07,1.36c-7.55,0-11.88-4.25-11.88-11,0-5.48,3.53-11.54,11.23-11.54,7.22,0,9.95,5.43,9.95,10.77a12.4,12.4,0,0,1-.25,2.65Zm8.14-4.59c0-1.61-.74-4.37-3.89-4.37-2.93,0-4.12,2.59-4.31,4.37Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-2"
          d="M283,63.49l1.79,8.84c.44,2.22.89,4.62,1.26,7.07h.11c.42-2.44,1.09-4.9,1.63-7l2.34-8.89h5.49l2.22,8.6c.6,2.46,1.19,4.87,1.62,7.32h.11c.31-2.44.76-4.88,1.3-7.35l1.89-8.55h6.77l-6.82,21.54h-6.49l-2.1-7.57c-.57-2.12-1-4-1.44-6.73h-.1a51.17,51.17,0,0,1-1.42,6.7L288.9,85h-6.5l-6.5-21.55Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M201.47,99.65h-1.11V91.06h1.11l3,5.23h0l3-5.23h1.11v8.59h-1.11v-5.1l0-1.44h0l-2.69,4.72h-.64l-2.69-4.72h-.05l.05,1.44Zm9.89-1.8a.88.88,0,0,0,.36.72,1.4,1.4,0,0,0,.87.29,1.71,1.71,0,0,0,1.23-.52,1.6,1.6,0,0,0,.55-1.21,2.26,2.26,0,0,0-1.44-.41,1.86,1.86,0,0,0-1.12.33A1,1,0,0,0,211.36,97.85Zm1.43-4.27a2.71,2.71,0,0,1,1.93.66,2.31,2.31,0,0,1,.71,1.79v3.62h-1.06v-.82h0a2.11,2.11,0,0,1-1.83,1,2.4,2.4,0,0,1-1.63-.57,1.87,1.87,0,0,1-.65-1.44,1.76,1.76,0,0,1,.69-1.46,2.92,2.92,0,0,1,1.84-.54,3.24,3.24,0,0,1,1.62.36v-.25a1.24,1.24,0,0,0-.45-1,1.57,1.57,0,0,0-1.07-.41,1.68,1.68,0,0,0-1.46.78l-1-.61A2.71,2.71,0,0,1,212.79,93.58Zm9.66,6.07h-1.34l-1.83-2.77-.9.89v1.88h-1.11V91.06h1.11v5.29l2.54-2.58h1.42v0l-2.29,2.28,2.4,3.5Zm2.65-7.91a.74.74,0,0,1-.22.55.75.75,0,0,1-.56.23.73.73,0,0,1-.55-.23.75.75,0,0,1-.23-.55.79.79,0,0,1,.78-.78.79.79,0,0,1,.56.23A.75.75,0,0,1,225.1,91.74Zm-.22,2v5.88h-1.11V93.77Zm2,0H228v.82H228a1.89,1.89,0,0,1,.76-.72,2.21,2.21,0,0,1,1.1-.29,2.14,2.14,0,0,1,1.65.62,2.44,2.44,0,0,1,.59,1.75v3.7H231V96a1.3,1.3,0,0,0-1.46-1.44,1.37,1.37,0,0,0-1.1.54A1.87,1.87,0,0,0,228,96.4v3.25h-1.11Zm9.69,5.06a1.7,1.7,0,0,0,1.33-.58,2.21,2.21,0,0,0,.54-1.54,2.17,2.17,0,0,0-.54-1.52,1.7,1.7,0,0,0-1.33-.6,1.73,1.73,0,0,0-1.34.6,2.41,2.41,0,0,0,0,3A1.73,1.73,0,0,0,236.6,98.83Zm0,3.6a3.05,3.05,0,0,1-.92-.13,2.57,2.57,0,0,1-.79-.35,2.48,2.48,0,0,1-1-1.23l1-.43a1.66,1.66,0,0,0,.63.82,1.73,1.73,0,0,0,1,.32,1.81,1.81,0,0,0,1.4-.54,2.09,2.09,0,0,0,.51-1.49v-.57h-.05a2.21,2.21,0,0,1-.85.75,2.62,2.62,0,0,1-1.15.26,2.59,2.59,0,0,1-2-.9,3.43,3.43,0,0,1,0-4.45,2.57,2.57,0,0,1,2-.91,2.5,2.5,0,0,1,1.15.27,2.11,2.11,0,0,1,.85.74h.05v-.82h1.06V99.4a3,3,0,0,1-.81,2.22A2.92,2.92,0,0,1,236.56,102.43Zm9.25-2.78h-1.1V93.77h1v1h.05a1.53,1.53,0,0,1,.69-.79,1.86,1.86,0,0,1,1-.34,2,2,0,0,1,.81.15L248,94.81a2,2,0,0,0-.65-.08,1.45,1.45,0,0,0-1.09.5,1.69,1.69,0,0,0-.46,1.18Zm6.13.19a2.78,2.78,0,0,1-2.13-.89,3.13,3.13,0,0,1-.84-2.24,3.17,3.17,0,0,1,.81-2.23,2.7,2.7,0,0,1,2.09-.9,2.66,2.66,0,0,1,2.08.85,3.34,3.34,0,0,1,.78,2.36v.12H250.1a1.91,1.91,0,0,0,.57,1.4,1.88,1.88,0,0,0,3-.53l1,.48a2.93,2.93,0,0,1-1.1,1.16A3,3,0,0,1,251.94,99.84ZM250.18,96h3.37a1.45,1.45,0,0,0-.5-1,1.72,1.72,0,0,0-1.2-.4,1.59,1.59,0,0,0-1.08.38A1.87,1.87,0,0,0,250.18,96Zm6.16-2.23h1.05v.82h.05a2,2,0,0,1,.77-.72,2.39,2.39,0,0,1,2.75.33,2.44,2.44,0,0,1,.59,1.75v3.7h-1.11V96A1.3,1.3,0,0,0,259,94.59a1.36,1.36,0,0,0-1.1.54,1.88,1.88,0,0,0-.45,1.27v3.25h-1.1Zm9.12,6a1.72,1.72,0,0,1-1.2-.45,1.62,1.62,0,0,1-.47-1.23V94.78h-1v-1h1V92h1.1v1.8h1.44v1h-1.44v2.93a1,1,0,0,0,.23.8.72.72,0,0,0,.51.2,1,1,0,0,0,.25,0,1.35,1.35,0,0,0,.24-.08l.35,1A3.06,3.06,0,0,1,265.46,99.75Zm3.21-1.9a.88.88,0,0,0,.36.72,1.35,1.35,0,0,0,.86.29,1.73,1.73,0,0,0,1.24-.52,1.63,1.63,0,0,0,.55-1.21,2.3,2.3,0,0,0-1.44-.41,1.87,1.87,0,0,0-1.13.33A.94.94,0,0,0,268.67,97.85Zm1.42-4.27a2.75,2.75,0,0,1,1.94.66,2.31,2.31,0,0,1,.7,1.79v3.62h-1.05v-.82h-.05a2.09,2.09,0,0,1-1.82,1,2.43,2.43,0,0,1-1.64-.57,1.86,1.86,0,0,1-.64-1.44,1.75,1.75,0,0,1,.68-1.46,2.93,2.93,0,0,1,1.85-.54,3.29,3.29,0,0,1,1.62.36v-.25a1.22,1.22,0,0,0-.46-1,1.56,1.56,0,0,0-1.07-.41,1.69,1.69,0,0,0-1.46.78l-1-.61A2.7,2.7,0,0,1,270.09,93.58Zm5.59-2.52v8.59h-1.1V91.06Zm7.83,8.78a2.79,2.79,0,0,1-2.14-.89,3.42,3.42,0,0,1,0-4.47,2.91,2.91,0,0,1,4.16,0,3.34,3.34,0,0,1,.78,2.36v.12h-4.62a1.94,1.94,0,0,0,.57,1.4,1.88,1.88,0,0,0,3-.53l1,.48a2.93,2.93,0,0,1-1.1,1.16A3,3,0,0,1,283.51,99.84ZM281.74,96h3.37a1.45,1.45,0,0,0-.5-1,1.72,1.72,0,0,0-1.2-.4,1.59,1.59,0,0,0-1.08.38A1.87,1.87,0,0,0,281.74,96Zm7,1.85a.88.88,0,0,0,.36.72,1.4,1.4,0,0,0,.87.29,1.71,1.71,0,0,0,1.23-.52,1.6,1.6,0,0,0,.55-1.21,2.26,2.26,0,0,0-1.44-.41,1.84,1.84,0,0,0-1.12.33A1,1,0,0,0,288.76,97.85Zm1.43-4.27a2.71,2.71,0,0,1,1.93.66,2.31,2.31,0,0,1,.71,1.79v3.62h-1.06v-.82h0a2.11,2.11,0,0,1-1.83,1,2.4,2.4,0,0,1-1.63-.57,1.87,1.87,0,0,1-.65-1.44,1.78,1.78,0,0,1,.68-1.46,3,3,0,0,1,1.85-.54,3.24,3.24,0,0,1,1.62.36v-.25a1.24,1.24,0,0,0-.45-1,1.57,1.57,0,0,0-1.07-.41,1.68,1.68,0,0,0-1.46.78l-1-.61A2.71,2.71,0,0,1,290.19,93.58ZM299.12,98a1.59,1.59,0,0,1-.68,1.29,2.59,2.59,0,0,1-1.69.53,2.75,2.75,0,0,1-1.56-.45,2.58,2.58,0,0,1-1-1.23l1-.42a1.88,1.88,0,0,0,.62.83,1.67,1.67,0,0,0,1.79.06.64.64,0,0,0,.36-.54c0-.38-.29-.65-.87-.83l-1-.25c-1.15-.29-1.72-.84-1.72-1.66a1.53,1.53,0,0,1,.65-1.28,2.72,2.72,0,0,1,1.68-.49,2.64,2.64,0,0,1,1.4.37,2,2,0,0,1,.89,1l-1,.4a1.24,1.24,0,0,0-.56-.57,1.55,1.55,0,0,0-.84-.22,1.44,1.44,0,0,0-.78.22.62.62,0,0,0-.33.53c0,.33.31.57,1,.72l.88.22C298.53,96.54,299.12,97.13,299.12,98Zm6.81-4.25-3.68,8.47h-1.14l1.37-3-2.43-5.51h1.2L303,98h0l1.7-4.22Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M133.37,147.29h-1.84V133h1.84Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M137.77,147.29h-1.84v-9.8h1.76v1.36h.08a3.27,3.27,0,0,1,1.29-1.2,3.57,3.57,0,0,1,1.73-.48,3.62,3.62,0,0,1,1.9.5,2.88,2.88,0,0,1,1.2,1.38,3.83,3.83,0,0,1,3.38-1.88,3.32,3.32,0,0,1,2.62,1,4.34,4.34,0,0,1,.92,3v6.12H149v-5.84a3.17,3.17,0,0,0-.5-2,2,2,0,0,0-1.68-.61,2.19,2.19,0,0,0-1.78.9,3.3,3.3,0,0,0-.72,2.12v5.42h-1.84v-5.84a3.17,3.17,0,0,0-.5-2,2,2,0,0,0-1.68-.61,2.19,2.19,0,0,0-1.78.9,3.3,3.3,0,0,0-.72,2.12Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M156.59,137.17a4.55,4.55,0,0,1,3.22,1.09,3.86,3.86,0,0,1,1.18,3v6h-1.76v-1.36h-.08a3.51,3.51,0,0,1-3,1.68,4,4,0,0,1-2.71-1,3.06,3.06,0,0,1-1.09-2.4,2.91,2.91,0,0,1,1.15-2.42,4.85,4.85,0,0,1,3.07-.9,5.45,5.45,0,0,1,2.7.6v-.42a2.09,2.09,0,0,0-.76-1.63,2.6,2.6,0,0,0-1.78-.67,2.81,2.81,0,0,0-2.44,1.3l-1.62-1A4.51,4.51,0,0,1,156.59,137.17Zm-2.38,7.12a1.46,1.46,0,0,0,.61,1.2,2.24,2.24,0,0,0,1.43.48,3,3,0,0,0,2.07-.86,2.68,2.68,0,0,0,.91-2,3.79,3.79,0,0,0-2.4-.68A3.11,3.11,0,0,0,155,143,1.61,1.61,0,0,0,154.21,144.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M167.31,151.93a5.46,5.46,0,0,1-1.54-.21,5,5,0,0,1-1.31-.59,4.15,4.15,0,0,1-1-.9,3.87,3.87,0,0,1-.64-1.16l1.74-.72a2.8,2.8,0,0,0,1,1.38,2.89,2.89,0,0,0,1.72.52,3,3,0,0,0,2.34-.9,3.5,3.5,0,0,0,.84-2.48v-.94h-.08a3.67,3.67,0,0,1-1.41,1.23,4.22,4.22,0,0,1-1.93.45,4.33,4.33,0,0,1-3.3-1.5,5.42,5.42,0,0,1-1.36-3.72,5.34,5.34,0,0,1,1.36-3.7,4.32,4.32,0,0,1,3.3-1.52,4.22,4.22,0,0,1,1.93.45,3.67,3.67,0,0,1,1.41,1.23h.08v-1.36h1.76v9.38a5,5,0,0,1-1.34,3.7A4.86,4.86,0,0,1,167.31,151.93Zm.06-6a2.82,2.82,0,0,0,2.22-1,4.06,4.06,0,0,0,0-5.1,2.83,2.83,0,0,0-2.22-1,2.86,2.86,0,0,0-2.22,1,3.65,3.65,0,0,0-.9,2.54,3.6,3.6,0,0,0,.9,2.54A2.86,2.86,0,0,0,167.37,145.93Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M178.79,147.61a4.67,4.67,0,0,1-3.56-1.48,5.24,5.24,0,0,1-1.4-3.74,5.31,5.31,0,0,1,1.36-3.73,4.89,4.89,0,0,1,6.95-.08,5.64,5.64,0,0,1,1.29,3.95l0,.2h-7.7a3.23,3.23,0,0,0,1,2.32,3.1,3.1,0,0,0,5-.88l1.64.8a4.89,4.89,0,0,1-1.83,1.94A5,5,0,0,1,178.79,147.61Zm-2.94-6.4h5.62a2.43,2.43,0,0,0-.83-1.69,2.89,2.89,0,0,0-2-.67,2.66,2.66,0,0,0-1.79.64A3.07,3.07,0,0,0,175.85,141.21Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M189.51,137.49h1.76v1.36h.08a3.27,3.27,0,0,1,1.29-1.2,3.69,3.69,0,0,1,1.81-.48,3.61,3.61,0,0,1,2.77,1,4.1,4.1,0,0,1,1,2.93v6.16h-1.84v-6a2.16,2.16,0,0,0-2.42-2.4,2.31,2.31,0,0,0-1.84.89,3.23,3.23,0,0,0-.74,2.13v5.42h-1.84Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M199.79,142.39a5.17,5.17,0,0,1,1.42-3.74,4.83,4.83,0,0,1,3.62-1.48,4.77,4.77,0,0,1,3.6,1.48,5.58,5.58,0,0,1,0,7.48,4.77,4.77,0,0,1-3.6,1.48,4.83,4.83,0,0,1-3.62-1.48A5.17,5.17,0,0,1,199.79,142.39Zm1.84,0a3.6,3.6,0,0,0,.92,2.56,3.14,3.14,0,0,0,4.56,0,4,4,0,0,0,0-5.1,3.1,3.1,0,0,0-4.56,0A3.57,3.57,0,0,0,201.63,142.39Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M215.13,147.45a2.82,2.82,0,0,1-2-.74,2.72,2.72,0,0,1-.81-2.06v-5.48h-1.72v-1.68h1.72v-3h1.84v3h2.4v1.68h-2.4v4.88a1.8,1.8,0,0,0,.38,1.33,1.24,1.24,0,0,0,.86.35,2,2,0,0,0,.43,0,2.23,2.23,0,0,0,.39-.13l.58,1.64A5,5,0,0,1,215.13,147.45Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M226.45,137.17a4.55,4.55,0,0,1,3.22,1.09,3.86,3.86,0,0,1,1.18,3v6h-1.76v-1.36H229a3.51,3.51,0,0,1-3,1.68,4,4,0,0,1-2.71-1,3.06,3.06,0,0,1-1.09-2.4,2.91,2.91,0,0,1,1.15-2.42,4.85,4.85,0,0,1,3.07-.9,5.45,5.45,0,0,1,2.7.6v-.42a2.09,2.09,0,0,0-.76-1.63,2.6,2.6,0,0,0-1.78-.67,2.81,2.81,0,0,0-2.44,1.3l-1.62-1A4.51,4.51,0,0,1,226.45,137.17Zm-2.38,7.12a1.46,1.46,0,0,0,.61,1.2,2.24,2.24,0,0,0,1.43.48,3,3,0,0,0,2.07-.86,2.68,2.68,0,0,0,.91-2,3.79,3.79,0,0,0-2.4-.68,3.11,3.11,0,0,0-1.87.54A1.61,1.61,0,0,0,224.07,144.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M237.49,147.29h-1.84l-4-9.8h2l2.88,7.6h0l2.92-7.6h2Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M246.21,137.17a4.55,4.55,0,0,1,3.22,1.09,3.86,3.86,0,0,1,1.18,3v6h-1.76v-1.36h-.08a3.51,3.51,0,0,1-3,1.68,4,4,0,0,1-2.71-1,3.06,3.06,0,0,1-1.09-2.4,2.91,2.91,0,0,1,1.15-2.42,4.85,4.85,0,0,1,3.07-.9,5.45,5.45,0,0,1,2.7.6v-.42a2.09,2.09,0,0,0-.76-1.63,2.6,2.6,0,0,0-1.78-.67,2.81,2.81,0,0,0-2.44,1.3l-1.62-1A4.51,4.51,0,0,1,246.21,137.17Zm-2.38,7.12a1.46,1.46,0,0,0,.61,1.2,2.24,2.24,0,0,0,1.43.48,3,3,0,0,0,2.07-.86,2.68,2.68,0,0,0,.91-2,3.79,3.79,0,0,0-2.4-.68,3.11,3.11,0,0,0-1.87.54A1.61,1.61,0,0,0,243.83,144.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M255.07,134.11a1.3,1.3,0,1,1-.38-.92A1.26,1.26,0,0,1,255.07,134.11Zm-.38,3.38v9.8h-1.84v-9.8Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M258.93,133v14.32h-1.84V133Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M264.79,137.17a4.55,4.55,0,0,1,3.22,1.09,3.86,3.86,0,0,1,1.18,3v6h-1.76v-1.36h-.08a3.51,3.51,0,0,1-3,1.68,4,4,0,0,1-2.71-1,3.06,3.06,0,0,1-1.09-2.4,2.91,2.91,0,0,1,1.15-2.42,4.85,4.85,0,0,1,3.07-.9,5.45,5.45,0,0,1,2.7.6v-.42a2.09,2.09,0,0,0-.76-1.63,2.6,2.6,0,0,0-1.78-.67,2.81,2.81,0,0,0-2.44,1.3l-1.62-1A4.51,4.51,0,0,1,264.79,137.17Zm-2.38,7.12a1.46,1.46,0,0,0,.61,1.2,2.24,2.24,0,0,0,1.43.48,3,3,0,0,0,2.07-.86,2.68,2.68,0,0,0,.91-2,3.79,3.79,0,0,0-2.4-.68,3.11,3.11,0,0,0-1.87.54A1.61,1.61,0,0,0,262.41,144.29Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M276.45,147.61a4.18,4.18,0,0,1-2-.46,3.47,3.47,0,0,1-1.37-1.22H273v1.36h-1.76V133h1.84v4.52l-.08,1.36h.08a3.47,3.47,0,0,1,1.37-1.22,4.18,4.18,0,0,1,2-.46,4.22,4.22,0,0,1,3.28,1.52,5.65,5.65,0,0,1,0,7.4A4.22,4.22,0,0,1,276.45,147.61Zm-.3-1.68a2.86,2.86,0,0,0,2.22-1,3.6,3.6,0,0,0,.9-2.54,3.65,3.65,0,0,0-.9-2.54,3,3,0,0,0-4.46,0,4.13,4.13,0,0,0,0,5.1A2.93,2.93,0,0,0,276.15,145.93Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M284.53,133v14.32h-1.84V133Z"
          transform="translate(-0.18)"
        />
        <path
          className="cls-3"
          d="M291.07,147.61a4.67,4.67,0,0,1-3.56-1.48,5.24,5.24,0,0,1-1.4-3.74,5.31,5.31,0,0,1,1.36-3.73,4.89,4.89,0,0,1,6.95-.08,5.64,5.64,0,0,1,1.29,3.95l0,.2H288a3.23,3.23,0,0,0,1,2.32,3.1,3.1,0,0,0,5-.88l1.64.8a4.89,4.89,0,0,1-1.83,1.94A5,5,0,0,1,291.07,147.61Zm-2.94-6.4h5.62a2.43,2.43,0,0,0-.83-1.69,2.89,2.89,0,0,0-2-.67,2.66,2.66,0,0,0-1.79.64A3.07,3.07,0,0,0,288.13,141.21Z"
          transform="translate(-0.18)"
        />
      </g>
      <defs>
        <clipPath id="cls-1">
          <rect className="cls-1" width={wSize} height={hSize} fill="#eeeeee" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default avenewImg;
